<template>
  <div>
    <modal-cadu close :width="940" v-model="valueData">
      <div slot="all" class="py-10 px-10">
        <div slot="header" class="primary1--text headline font-weight-bold">{{ nomeAcao }} DIRIGENTE</div>

        <div slot="body">
          <component-loading :value="isLoading" />

          <ValidationObserver ref="observer">
            <div v-if="!isLoading">
              <v-row>
                <v-col cols="12" md="6" v-if="nomeAcao === 'ADICIONAR'">
                  <search-bar
                    nameInput="searchText"
                    nameButton="searchBtn"
                    ref="barraPesquisa"
                    v-model="barraPesquisa"
                    placeholder="pesquisar por nome ou cpf"
                    @pesquisar="pesquisar"
                    @selecionado="preencherCampos"
                    :items="pesquisaNova"
                    quadrado
                  />
                </v-col>

                <v-col cols="auto" align-self="center">
                  <checkbox-cadu
                    :disable="nomeAcao === 'VISUALIZAR' || disableNaoMedico || isDirigente || atualizaOnline"
                    v-model="naoMedico"
                  >
                    <div slot="text">Não Médico</div>
                  </checkbox-cadu>
                </v-col>

                <v-col cols="auto" align-self="center">
                  <v-row>
                    <v-col cols="auto" align-self="start">
                      <checkbox-cadu
                        :disable="nomeAcao === 'VISUALIZAR' || disableAtualizaOnline || isDirigente || naoMedico"
                        v-model="atualizaOnline"
                      >
                        <div slot="text">Atualização On-line</div>
                      </checkbox-cadu>
                    </v-col>
                    <tooltip-help
                      width="290"
                      text="Dados atualizados pelo sistema Gestão de Redes da Unimed do Brasil, conforme informações do PTU A400"
                    />
                  </v-row>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="12" sm="2">
                  <ValidationProvider mode="eager" rules="required" v-slot:default="{ errors }">
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="Tratamento"
                      disabled
                      :value="tratamentoComputed"
                      @input="(input) => (tratamento = input)"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="9">
                  <ValidationProvider mode="eager" rules="required|max:60" v-slot:default="{ errors }">
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="Nome"
                      :disabled="nomeAcao === 'VISUALIZAR' || atualizaOnline || isDirigente"
                      v-model="nome"
                      :max="60"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="2">
                  <ValidationProvider
                    mode="eager"
                    :rules="!naoMedico ? 'required|max:8' : 'max:8'"
                    v-slot:default="{ errors }"
                  >
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="CRM"
                      :disabled="nomeAcao === 'VISUALIZAR' || naoMedico || atualizaOnline || isDirigente"
                      v-model="crm"
                      onlyNumber
                      :max="8"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="2">
                  <ValidationProvider
                    mode="eager"
                    :rules="!naoMedico ? 'required|max:8' : 'max:8'"
                    v-slot:default="{ errors }"
                  >
                    <autocomplete-cadu
                      :errorMessage="errors[0]"
                      title="UF do CRM"
                      :disabled="nomeAcao === 'VISUALIZAR' || naoMedico || atualizaOnline || isDirigente"
                      v-model="uf.sigla"
                      :items="listaUfs.map((el) => el.sigla)"
                      @index="indexUf"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="4" v-if="!isColaboradorDirigente">
                  <ValidationProvider
                    mode="eager"
                    :rules="naoMedico ? 'required' : 'required|cpf'"
                    v-slot:default="{ errors }"
                  >
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="CPF"
                      mask="###.###.###-##"
                      :disabled="nomeAcao === 'VISUALIZAR' || atualizaOnline || isDirigente"
                      v-model="cpf"
                    />
                  </ValidationProvider>
                </v-col>

                <v-row>
                  <v-col cols="12" md="auto" class="pt-5">
                    <div class="fontColor--text">SEXO</div>

                    <v-row>
                      <v-col cols="auto" class="pt-0">
                        <checkbox-cadu
                          :error="errorCheck"
                          v-model="sexo"
                          @input="errorCheck = false"
                          :disable="nomeAcao === 'VISUALIZAR' || atualizaOnline || isDirigente"
                          obligatory
                          single
                          value="F"
                          rounded
                        >
                          <div slot="text">Feminino</div>
                        </checkbox-cadu>
                      </v-col>

                      <v-col cols="auto" class="pt-0">
                        <checkbox-cadu
                          :error="errorCheck"
                          v-model="sexo"
                          @input="errorCheck = false"
                          :disable="nomeAcao === 'VISUALIZAR' || atualizaOnline || isDirigente"
                          obligatory
                          single
                          value="M"
                          rounded
                        >
                          <div slot="text">Masculino</div>
                        </checkbox-cadu>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-col cols="12" md="3" v-if="!isColaboradorDirigente">
                  <datepicker-cadu
                    :inputTitle="'Data Nascimento'"
                    :inputValue="dataNascimento"
                    :disabled="nomeAcao === 'VISUALIZAR' || atualizaOnline || isDirigente"
                    :validateProviderRules="
                      naoMedico ? 'required|dateValidator|dateValidatorForPass' : 'required|dateValidator'
                    "
                    typeCalendar="date"
                    :maxDate="today"
                    @value="(value) => (dataNascimento = value)"
                    width="280"
                  />
                </v-col>
              </v-row>
            </div>
          </ValidationObserver>

          <v-row v-if="nomeAcao === 'VISUALIZAR' || nomeAcao === 'EDITAR'">
            <v-col>
              <TabelaMandatos
                ref="tabelaMandatos"
                @view="(obj) => getId(false, obj)"
                @edit="(obj) => getId(true, obj)"
                :nomeAcao="nomeAcao"
                :idDirigente="idDirigente"
                :role="role"
              />
            </v-col>
          </v-row>

          <component-loading :value="isLoadingInfo" />

          <div class="container-dirigente" v-if="showDirigenteInfo">
            <ValidationObserver ref="observerDirigente">
              <v-row>
                <v-col cols="12" md="9">
                  <div v-for="(email, index) in emails" :key="index">
                    <v-row>
                      <v-col cols="8" md="8">
                        <ValidationProvider ref="email.emailAdress" mode="eager" rules="required|email|max:100" v-slot:default="{ errors }">
                          <input-cadu
                            :errorMessage="errors[0]"
                            :disabled="nomeAcao === 'VISUALIZAR'"
                            title="E-mail"
                            v-model="email.emailAdress"
                            :max="50"
                            emailMask
                            :colorText="$vuetify.theme.themes.light.fontColor1"
                            :onlylowerCase="true"
                          />
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="3" md="3" class="pd-top-icon">
                        <button-rounded
                          v-if="nomeAcaoDirigente === 'EDITAR'"
                          iconName="plus"
                          :iconSize="16"
                          @click="addMore()"
                          :backColor="$vuetify.theme.themes.light.primary2"
                          title="Adicionar"
                        />

                        <button-rounded
                          iconName="x"
                          :iconSize="16"
                          v-if="emails.length > 1 && index != 0 && nomeAcaoDirigente === 'EDITAR'"
                          @click="remove(index)"
                          v-show="index != 0"
                          :backColor="$vuetify.theme.themes.light.primary2"
                          title="Excluir"
                        />
                      </v-col>
                    </v-row>
                  </div>

                  <!-- <v-btn density="compact" icon="mdi-plus" @click="addMore()"></v-btn> -->

                  <!-- <button
                      type="button"
                      class="flex justify-start ml-2 rounded-md border px-3 py-2 bg-pink-600 text-white"
                      @click="addMore()"
                    > Adicionar
                  </button> -->
                </v-col>
                <!-- <v-col align-self="start"></v-col> -->
              </v-row>

              <v-row>
                <v-col cols="12" md="3">
                  <ValidationProvider ref="telefone" mode="eager" rules="required|min:14" v-slot:default="{ errors }">
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="Telefone"
                      :disabled="disabledDirigenteInfo"
                      v-model="telefoneComercial"
                      mask="(##) #####-####"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="3">
                  <ValidationProvider ref="celular" mode="eager" rules="required|min:14" v-slot:default="{ errors }">
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="Celular"
                      :disabled="disabledDirigenteInfo"
                      mask="(##) #####-####"
                      v-model="telefoneCelular"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col
                  class="pt-5"
                  align-self="center"
                  cols="auto"
                  v-if="nomeAcaoDirigente === 'EDITAR' && showDirigenteInfo"
                >
                  <button-cadu @click="cancelarEdicaoDirigente" outline> CANCELAR </button-cadu>
                </v-col>

                <v-col
                  class="pt-5"
                  align-self="center"
                  cols="auto"
                  v-if="nomeAcaoDirigente === 'EDITAR' && showDirigenteInfo"
                >
                  <button-cadu @click="salvarDirigenteEdit"> SALVAR </button-cadu>
                </v-col>
              </v-row>
            </ValidationObserver>
          </div>
        </div>

        <div slot="footer" class="pt-4">
          <v-row align="center" justify="end" no-gutters v-if="nomeAcao === 'VISUALIZAR'">
            <v-col cols="auto">
              <button-cadu @click="fecharModal"> VOLTAR </button-cadu>
            </v-col>
          </v-row>

          <v-row justify="start" v-if="nomeAcao === 'ADICIONAR'">
            <v-col cols="auto"> <button-cadu outline @click="fecharModal"> VOLTAR </button-cadu> </v-col>

            <v-row justify="end">
              <v-col cols="auto">
                <button-cadu
                  @click="salvarNovamente"
                  :backColor="$vuetify.theme.themes.light.primary2"
                  block
                  class="mx-4"
                >
                  SALVAR E ADICIONAR OUTRO
                </button-cadu>
              </v-col>

              <v-col cols="auto">
                <button-cadu @click="salvarDados"> SALVAR </button-cadu>
              </v-col>
            </v-row>
          </v-row>

          <v-row justify="start" v-if="nomeAcao === 'EDITAR'">
            <v-col cols="auto">
              <button-cadu @click="verifyCancelar" outline> CANCELAR </button-cadu>
            </v-col>

            <v-row justify="end">
              <v-col cols="auto">
                <button-cadu :backColor="$vuetify.theme.themes.light.primary2" @click="limparCamposNaoMedico">
                  LIMPAR
                </button-cadu>
              </v-col>

              <v-col cols="auto">
                <button-cadu @click="salvarDados"> SALVAR </button-cadu>
              </v-col>
            </v-row>
          </v-row>
        </div>
      </div>
    </modal-cadu>

    <modal-cancelar
      :value="showModalCancelar"
      @input="fecharModalCancelarNaoMedico"
      @cancelar-edicao="cancelarModalDirigente"
    />

    <error-modal :value="showError" @input="fecharModalErro" :errObj="errObj" />

    <overlay-loading v-model="loadingOverlay" />

    <SucessoModal :genericMessage="genericMessage" :showSucess="showSucess" @close="fecharModalSucesso" />

    <SucessoModal
      :genericMessage="genericMessage"
      :showSucess="showSucessDirigente"
      @close="fecharModalSucessoDirigente"
    />

    <modal-cancelar
      :value="showModalCancelarDirigente"
      @input="cancelarDirigente"
      @cancelar-edicao="fecharModalCancelar"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Dirigentes from '@/services/Dirigentes/Dirigentes'
import Estado from '@/services/AreaAcao/Estado'
import TabelaMandatos from './Shared/TabelaMandatos'
import { isEqual } from 'lodash'
import moment from 'moment'
import jwtDecode from 'jwt-decode'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    TabelaMandatos
  },
  props: {
    nomeAcao: {
      type: String,
      default: 'VISUALIZAR',
      validator: (el) => ['VISUALIZAR', 'EDITAR', 'ADICIONAR'].includes(el)
    },
    idDirigente: {
      type: [Number, String],
      default: ''
    },
    idMandato: {
      typé: [String, Number],
      default: ''
    },
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      showModalCancelar: false,
      tratamento: '',
      nome: '',
      crm: '',
      uf: {
        id: '',
        sigla: ''
      },
      cpf: '',
      sexo: [],
      dataNascimento: '',
      naoMedico: true,

      showError: false,
      errObj: {},
      isLoading: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      dirigentes: '',
      telefoneResidencial: '',
      listaUfs: [],
      loadingOverlay: false,
      showSucess: false,
      genericMessage: '',
      barraPesquisa: '',
      pesquisaNova: [],
      novamente: false,
      valueData: this.value,
      email: '',
      emails: [
        {
          emailAdress: ''
        }
      ],
      telefoneComercial: '',
      telefoneCelular: '',
      showDirigenteInfo: false,
      disabledDirigenteInfo: false,
      isLoadingInfo: false,
      showModalCancelarDirigente: false,
      cloneObj: {},
      idDirigenteCargo: '',
      idMandatoCargo: '',
      idUnimed: '',
      showSucessDirigente: false,
      nomeAcaoDirigente: 'VISUALIZAR',
      objCloneDirigente: {},
      errorCheck: false,
      today: moment().format('DD/MM/YYYY'),
      role: '',
      emailRules: [(v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido'],

      atualizaOnline: false,
      //sua função é guardar o estado inicial do campo de atualização online
      atualizaOnlineInicial: false,
      disableAtualizaOnline: false,
      disableNaoMedico: false
    }
  },
  beforeMount() {
    this.role = jwtDecode(this.tokenBearer).role

    if (this.isDirigente && this.nomeAcao === 'ADICIONAR') {
      this.naoMedico = false
      this.atualizaOnline = true
    }

    this.getEstados()
  },
  methods: {
    addMore() {
      this.emails.push({
        emailAdress: ''
      })
    },
    remove(index) {
      this.emails.splice(index, 1)
    },
    async cancelarModalDirigente() {
      this.showModalCancelar = false;
      this.$emit('input', false);
      this.$emit('desativarModal', false);
      document.documentElement.style.overflow = 'hidden';
      await this.getDirigente()
      await this.$nextTick()
    },
    async cancelarDirigente() {
      this.showModalCancelarDirigente = false;
      document.documentElement.style.overflow = 'hidden'
      await this.$nextTick();
      this.$emit('input', false);
      this.$emit('desativarModal', false);
    },
    async fecharModalCancelarNaoMedico() {
      this.showModalCancelar = false
      document.documentElement.style.overflow = 'hidden'
      await this.$nextTick();
      this.$emit('input', false);
      this.$emit('desativarModal', false);
    },
    async fecharModalCancelar() {
      this.showModalCancelarDirigente = false
      this.editMandato()
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
      this.$emit('input', false);
      this.$emit('desativarModal', false);

    },
    async fecharModalSucessoDirigente() {
      this.showSucessDirigente = false
      await this.$refs.tabelaMandatos.getTabela()
      document.documentElement.style.overflow = 'hidden'
      this.$emit('input', false);
    },
    async salvarDirigenteEdit() {
      const res = await this.$refs.observerDirigente.validate()

      if (!res) return

      let newEmails = []
      let emailsPopulados = this.emails.map((e) => e.emailAdress)
      emailsPopulados.forEach((e) => {
        if (!newEmails.includes(e)) newEmails.push(e)
      });
      newEmails = newEmails.join(',')

      const obj = {
        consultaDTO: {
          dirigenteCargoId: this.idDirigenteCargo,
          mandatoId: this.idMandatoCargo,
          unimedId: this.idUnimed
        },
        dirigenteCargoDTO: {
          cargo: {
            id: this.idDirigenteCargoDtoCargo
          },
          dirigente: {
            id: this.idDirigente
          },
          email: newEmails,
          id: this.idDirigenteCargo,
          telefoneCelular: this.telefoneCelular,
          telefoneComercial: this.telefoneComercial
        }
      }

      this.loadingOverlay = true
      await this.promiseGeneric(this.dirigentes, 'putDirigenteCargo', obj)
      this.loadingOverlay = false

      this.genericMessage = 'Dirigente editado com sucesso.'
      this.showSucessDirigente = true
      this.showDirigenteInfo = false
    },
    async viewMandato() {
      this.showDirigenteInfo = false
      this.disabledDirigenteInfo = true
      this.isLoadingInfo = true
      await this.getInfoDirigente()
      this.isLoadingInfo = false
      this.showDirigenteInfo = true
    },
    async editMandato() {
      this.showDirigenteInfo = false
      this.disabledDirigenteInfo = false
      this.isLoadingInfo = true
      await this.getInfoDirigente()
      this.isLoadingInfo = false
      this.showDirigenteInfo = true
    },
    async getInfoDirigente() {
      let res = await this.promiseGeneric(
        this.dirigentes,
        'getDirigenteInfo',
        this.idDirigenteCargo,
        this.idMandatoCargo,
        this.idUnimed
      )
      res = res.data

      this.cloneObj = {
        email: res.dirigenteCargo.email,
        telefoneCelular: res.dirigenteCargo.telefoneCelular,
        telefoneComercial: res.dirigenteCargo.telefoneComercial
      }

      this.idDirigenteCargoDtoCargo = res.dirigenteCargo.cargo.id || ''
      this.email = this.ajustarEmailDirigente(res.dirigenteCargo.email)
      this.telefoneCelular = res.dirigenteCargo.telefoneCelular
      this.telefoneComercial = res.dirigenteCargo.telefoneComercial
    },
    ajustarEmailDirigente(emailDirigente) {
      if (emailDirigente != null) {
        let emails = emailDirigente.split(',')
        let populateEmails = []
        emails.forEach((email) => {
          populateEmails.push({ emailAdress: email })
        })
        this.emails = populateEmails;
      } else {
        this.emails = [{emailAdress: '' }];
      }  
    },
    async preencherCampos(dirigente) {
      await this.$nextTick()

      if (!dirigente) return

      this.disableAtualizaOnline = false

      this.id = dirigente.id
      this.tratamento = dirigente.tratamento
      this.cpf = dirigente.cpf
      this.nome = dirigente.nome
      this.crm = dirigente.crm
      this.sexo = [dirigente.sexo]
      this.naoMedico = !dirigente.medico
      this.atualizaOnline = dirigente.atualizaOnline
      this.uf = dirigente.estadoCrm
      this.dataNascimento = dirigente.dataNascimento

      //this.disableNaoMedico = true;
      //this.naoMedico = false;
    },
    async fecharModalErro() {
      this.showError = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    async fecharModalSucesso() {
      this.showSucess = false

      if (this.novamente) {
        this.valueData = false
        this.limparCampos()
        await this.$nextTick()
        this.valueData = true
        document.documentElement.style.overflow = 'hidden'
        this.novamente = false
        return
      }
      this.valueData = false
      this.$emit('input', false)
      this.$emit('att')
    },
    async start() {
      this.dirigentes = new Dirigentes(this.tokenBearer, this.$appConfig.config.API)
      this.valueData = true

      await this.$nextTick()

      if (this.idDirigente) {
        this.getDirigente()
      }

      if (this.nomeAcao === 'ADICIONAR') {
        this.naoMedico = true
        this.atualizaOnline = false
      }
    },
    async getEstados() {
      const estado = new Estado(this.tokenBearer, this.$appConfig.config.API)
      const res = await this.promiseGeneric(estado, 'getEstados', '')
      this.listaUfs = res.data
    },
    async getDirigente() {
      this.isLoading = true

      await this.promiseGeneric(this.dirigentes, 'getDirigenteUnico', this.idDirigente)
        .then((res) => {
          res = res.data

          if (!res.medico) {
            this.objCloneDirigente = {
              tratamento: res.tratamento,
              nome: res.nome,
              crm: res.crm,
              uf: res.estadoCrm,
              cpf: res.cpf,
              sexo: res.sexo,
              dataNascimento: res.dataNascimento,
              naoMedico: !res.medico
            }
          }

          this.tratamento = res.tratamento
          this.nome = res.nome
          this.crm = res.crm
          this.uf = res.estadoCrm || { id: '', sigla: '' }
          this.cpf = res.cpf
          this.sexo = [res.sexo]
          this.dataNascimento = res.dataNascimento
          this.naoMedico = !res.medico
          this.atualizaOnline = res.atualizaOnline
          this.atualizaOnlineInicial = res.atualizaOnline
        })
        .finally(() => {
          this.disableAtualizaOnline = false
          this.isLoading = false
          document.documentElement.style.overflow = 'hidden'
        })
    },
    async pesquisar() {
      if (!this.barraPesquisa) return
      this.isLoading = true
      const res = await this.promiseGeneric(this.dirigentes, 'getPesquisaNova', this.barraPesquisa)
      if (res.data.length === 0) {
        this.showError = true
        this.errObj.error = 'Médico cooperado não localizado!'
      }
      this.pesquisaNova = res.data
      this.isLoading = false
      await this.$nextTick
      this.$refs.barraPesquisa.mostrarMenu = true
    },
    async salvarDados(salvarNovamente = false) {
      const refCheck = await this.$refs.observer.validate()
      this.errorCheck = this.sexo.length <= 0 && this.tratamento.length == 0

      if ((refCheck && !this.errorCheck) || this.isLoading) {
        this.novamente = salvarNovamente
        this.genericMessage = this.idDirigente ? 'Dirigente editado com sucesso' : 'Dirigente criado com sucesso'

        const estadoCrm = this.uf.sigla ? this.uf : null

        const obj = {
          id: this.idDirigente,
          nome: this.nome,
          cpf: this.cpf.replace(/[^0-9]/g, ''),
          tratamento: this.tratamento,
          crm: this.crm,
          dataNascimento: this.dataNascimento,
          estadoCrm,
          atualizaOnline: this.atualizaOnline,
          medico: !this.naoMedico,
          sexo: this.sexo[0],
          telefoneCelular: this.telefoneCelular,
          telefoneComercial: this.telefoneComercial,
          telefoneResidencial: this.telefoneResidencial
        }

        let func

        //atualizaOnline -> true && naoMedico -> false
        if (this.atualizaOnline && !this.naoMedico) {
          func = 'putMedico'
        } else {
          //naoMedico -> true
          if (this.naoMedico) {
            func = 'putNaoMedico'
          } else {
            func = 'putMedico'
          }
        }

        this.loadingOverlay = true

        await this.promiseGeneric(this.dirigentes, func, obj)

        this.loadingOverlay = false
        this.showSucess = true
        document.documentElement.style.overflow = 'hidden'
      }
    },
    getId(edicao, obj) {
      this.idDirigenteCargo = obj.idDirigenteCargo
      this.idMandatoCargo = obj.idMandato
      this.idUnimed = obj.idUnimed

      if (edicao) {
        this.nomeAcaoDirigente = 'EDITAR'
        this.editMandato()
        return
      }

      this.nomeAcaoDirigente = 'VISUALIZAR'
      this.viewMandato()
    },
    cancelarEdicaoDirigente() {
      const obj = {
        email: this.email,
        telefoneComercial: this.telefoneComercial.replace(/[^0-9.]/g, ''),
        telefoneCelular: this.telefoneCelular.replace(/[^0-9.]/g, '')
      }
      if (!isEqual(this.cloneObj, obj)) {
        this.showModalCancelarDirigente = true;
      } else {
        this.showModalCancelarDirigente = false;
        this.$emit('input', false);
      }
    },
    verifyCancelar() {
      const obj = {
        tratamento: this.tratamento,
        nome: this.nome,
        crm: this.crm,
        uf: this.uf,
        cpf: this.cpf.replace(/[^0-9]/g, ''),
        sexo: this.sexo[0],
        dataNascimento: this.dataNascimento,
        naoMedico: this.naoMedico
      }
      if (!isEqual(this.objCloneDirigente, obj)) {
        this.showModalCancelar = true;
      } else {
        this.showModalCancelar = false;
        this.$emit('input', false);
      }
    },
    promiseGeneric(className, nomeFunc, ...valoresFunc) {
      return new Promise(async (resolve, reject) => {
        try {
          resolve(await className[nomeFunc](...valoresFunc))
        } catch (err) {
          if (this.valueData) {
            this.isLoading = false
            this.loadingOverlay = false
            this.showError = true
            if (err.response) {
              this.errObj.status = err.response.status
              this.errObj.error = err.response.data.message
            }
            reject(err)
          }
        }
      })
    },
    indexUf(index) {
      this.uf.id = index > -1 && index !== null ? this.listaUfs[index].id : ''
    },
    limparCamposNaoMedico() {
      this.isLoading = true
      setTimeout(() => {
        this.errorCheck = false
        this.isLoadingInfo = false
        this.showDirigenteInfo = false
        this.pesquisaNova = []
        this.barraPesquisa = null
        this.nome = ''
        this.cpf = ''
        this.sexo = []
        this.dataNascimento = ''
        this.isLoading = false
        this.crm = ''
        this.uf = {
          id: '',
          sigla: ''
        }
      }, 100)
    },
    limparCampos() {
      this.errorCheck = false
      this.isLoadingInfo = false
      this.showDirigenteInfo = false
      this.pesquisaNova = []
      this.barraPesquisa = ''
      this.tratamento = ''
      this.nome = ''
      this.crm = ''
      this.uf = {
        id: '',
        sigla: ''
      }
      this.cpf = ''
      this.sexo = []
      this.dataNascimento = ''
      this.naoMedico = this.role === 'admin_brasil' && this.nomeAcao === 'ADICIONAR'
    },
    fecharModal() {
      this.atualizaOnline = false
      this.valueData = false
      this.disableNaoMedico = false
    },
    salvarNovamente() {
      this.salvarDados(true)
    },
    inputEvent(value) {
      if (value.length > 0 && value !== undefined && this.role === 'dirigente') {
        this.disableNaoMedico = true
      } else {
        this.disableNaoMedico = false
      }
    }
  },
  computed: {
    tratamentoComputed() {
      return this.senhorComputed
        ? 'SR'
        : this.senhoraComputed
        ? 'SRA'
        : this.medicoComputed
        ? 'DR'
        : this.medicaComputed
        ? 'DRA'
        : ''
    },
    senhorComputed() {
      return this.naoMedico && this.sexo[0] === 'M'
    },
    senhoraComputed() {
      return this.naoMedico && this.sexo[0] === 'F'
    },
    medicoComputed() {
      return !this.naoMedico && this.sexo[0] === 'M'
    },
    medicaComputed() {
      return !this.naoMedico && this.sexo[0] === 'F'
    },
    isAdminBrasil() {
      return this.role == 'admin_brasil'
    },
    isDirigente() {
      return this.role == 'dirigente'
    },
    isColaboradorDirigente() {
      return this.role === 'colaborador_dirigente'
    }
  },
  watch: {
    valueData() {
      if (this.novamente) return
      if (!this.valueData) {
        this.limparCampos()
        this.$emit('input', this.valueData)
      }
    },
    value() {
      this.valueData = this.value
    },
    tratamentoComputed() {
      this.tratamento = this.tratamentoComputed
    },
    atualizaOnline() {
      if (this.nomeAcao === 'EDITAR' && !this.isLoading) {
        if (this.naoMedico && !this.atualizaOnline)
          this.naoMedico = true //Por enquanto, tratamento Sr(a) apenas para esse caso, Dr(a) para o resto
        else this.naoMedico = false
      }
    }
  }
}
</script>

<style lang="sass">
.container-dirigente
  border: #00995d solid 1px
  padding: 10px
  border-radius: 10px

.pd-top-icon
  padding-top: 38px
</style>
